import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment';
import Papa from "papaparse";
import {
  BasicSelect
} from 'vue-search-select';
// import CProgress from '@coreui/vue/src/components/progress/CProgress'
// import { getLoggedInUserInfo as getUserInfo } from '../../../../libs/UserSessionInfo.js'


export default {
  name: 'Shipment Recovery upload',
  components: {
      VueElementLoading,
      Paginate,
      BasicSelect
      // CProgressBar
  },
  mixins:[PageTracker],
  data: function() {
      return {
        activeTab: 'upload', // default tab
        approvalfor: 'penaltydebitsrecovery',
        isDownloadFlag: false,
        errorList1: [],
        file: '',
        filename: '',
        recoveryfile: '',
        recoveryfilename: '',
        filedata: [],
        recoveryFiledata: [],
        PromiseChainResult: [],
        PromiseChainResult1: [],
        isLoading: false,
        isLoading1: false,
        isDownloadFlag: false,
        UpdateApprovalKey: [],
        uploadResult: [],
        recoveryuploadResult: [],
        errorList: [],
        errorList1: [],
        batchkeyArray: [],
        batchkeyArray1: [],
        UploadConfigDetails: {},
        uploadLimit : 0,
        userDataKey : '',
        isShow:true,
        isShow1:true,
        localusermailid:'',
        recoveryProcessedSummary: false,
        attachmentLoader: false,
        isScroll: false,
        isDownloadFlag: false,
        fromDate: '',
        toDate: '',
        debitFrom:'',
        debitFromList:[{ value: "ServiceCenter",text: "Service Center"},{ value: "Courier",text: "Super Agent"},{ value: "Coloader",text: "Coloader "},{ value: "Vendor",text: "Local Vendor"},{ value: "NetworkVendor",text: "Network Vendor"}],
        debitFromObj:{ value: "",text: ""},
        StatusList:[{ value: "Pending",text: "Pending For Recovery"},{ value: "AccountCloseDebit",text: "Account Closed / Recovered"}],
        status: "",
        StatusObj:{ value: "",text: ""},
        hubList: [],
        hublistObj:{value: "",text: ""},
        srLoader: "",
        hubname: '',
        employeeID: '',
        "shippingID": "",
        pageno: 1,
        pagecount: 0,
        pageLimit: 100,
        totalRecords: "0",
        searchflag: true,
        HRDebitData: [],
        selectedItems: "",
        ApproveResultResponse: [],
        filteredData: [],
        successCount: 0,
        failureCount: 0,
        losttype: 'Manual Delivery'
      }
  },
  created: function() {
  },
async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    // console.log('test -->>', currentDate.format('M'););
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    // let getconfig = await this.getconfigFlags()
    // this.UploadConfigDetails = JSON.parse(getconfig);
    // this.uploadLimit = this.UploadConfigDetails.pageCuttoff
    // console.log('this.UploadConfigDetails ----->>', this.UploadConfigDetails);

    let getHubList = localStorage.getItem('allhubaccesslist');
    let byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
    let hubList = byteHub.toString(CryptoJS.enc.Utf8);
    let loginHubAccessList = JSON.parse(hubList);
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);

    // format as YYYY-MM-DD for <input type="date">
    this.toDate = today.toISOString().substr(0, 10);
    this.fromDate = lastMonth.toISOString().substr(0, 10);

    //console.log('Mixin is working for :',result);
    this.getHubList(loginHubAccessList);
  },
  methods : {
    getDebitFromId(val) {
      switch (val.DebitFromType) {
        case 'ServiceCenter':
          return val.employeeId;
        case 'Store':
        case 'RSC':
        case 'BranchDebit':
          return val.DebitID;
        case 'Coloader':
          return val.ColoaderID;
        case 'Vendor':
        case 'NetworkVendor':
          return val.VehicleVendorID;
        case 'Courier':
          return val.CourierID;
        default:
          return '';
      }
    },
    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.exportFlag = false
      this.HRApproveFilter();
    },
    searchData() {
      this.searchflag = true;
      this.pageno = 1;
      // this.$refs.paginate.selected= 0;
      this.HRApproveFilter();
    },
    HRApproveFilter(){
      this.searchflag=true;
      this.loader = true;
      this.selectedItems = []
      let payload = {};
      if(this.fromDate != '') payload.fromDate = this.fromDate;
      if(this.toDate != '') payload.toDate = this.toDate;
      if(this.debitFrom != '') payload.debitfromtype = this.debitFrom;
      // if(this.hubname != '') payload.ServiceCenterName = this.hubname.toString();
      if(this.employeeID != '') payload.userid = this.employeeID.toString();
      if(this.shippingID != '') payload.shippingid = this.shippingID;
      payload.page = this.pageno;
      payload.limit = this.pageLimit;
      payload.recstatus = this.status
      payload.losttype = this.losttype
      this.ApproveResultResponse = [];

      axios({
          method: 'POST',
          url: apiUrl.api_url + 'get/pending/recoverylist',
          // url: 'http://localhost:3800/get/pending/recoverylist',
          data:payload
        })
        .then(result => {
          // console.log('result ======================>>>>>>>>>>>>>>>.', result.data);
          if(result.data.code == 200){
            this.successCount = 0
            this.failureCount = 0
            let getResultSet = result.data
            if(getResultSet.data.length > 0 ){
              for (const item of getResultSet.data) {
                if (item.recoverystatus === "AccountCloseDebit") {
                  this.successCount++;
                } else {
                  this.failureCount++;
                }
              }
              this.loader = false;

              // console.log("result.data ------------------------------------>>>>>>>>>", result.data.data);
                this.HRDebitData = getResultSet.data;
                this.totalRecords = getResultSet.totalRecords
                // let totalRows = result.data.shipcount;
                if (this.totalRecords < this.pageLimit) {
                    this.pagecount = 1;
                } else {
                    this.pagecount = Math.ceil(this.totalRecords / this.pageLimit)
                    console.log("this.pagecount ----------->.", this.pagecount);
                }
            }
            else {
              this.$alertify.error("No Pending Approval");
            }
          }
          else {
              this.HRDebitData = [];
              this.totalRecords = 0
              this.pagecount = 1;
              this.searchflag=false;
              this.loader = false;
              this.$alertify.error(result.data.message != undefined ? result.data.message : "No Pending Approval");
          }
        }, error => {
          this.loader = false;
          console.error(1,error)
        });
      },
      getFormatedDate(date){
        let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
        return year+'/'+month+'/'+day;
      },
    getStatus(obj){
      this.StatusObj = obj
      this.status = obj.value
    },
    gethubname(obj){
      this.hublistObj = obj
      this.hubname = this.hublistObj.value
      this.debitFromTypeObj = {value:"",text:""}
      this.debitFromType = ""
    },
    getHubList(hubs){

      this.hubList = hubs.map((hub) => {
        return {
          value: hub.HubID,
          text: hub.HubName
        }
      })
      console.log('this.hubList ---------------->>', this.hubList);
      this.hublistObj = this.hubList.filter((obj) => obj.value == this.hubID );
    },
    getDebitFrom(obj){
        this.debitFromObj = obj
        this.debitFrom = this.debitFromObj.value
        this.debitModeList = []
    },
    async chooseFile1(e){
        try {
          const file = e.target.files[0];

          if (!file) {
            throw new Error("No file selected.");
          }

          // Check file extension
          const fileName = file.name.toLowerCase();
          const isCsvExtension = fileName.endsWith(".csv");

          // Check MIME type (different browsers sometimes report differently)
          const isCsvMime = file.type === "text/csv" || file.type === "application/vnd.ms-excel";

          if (!isCsvExtension || !isCsvMime) {
            this.recoveryfilename = null;
            this.recoveryfile = null;
            // alert("Invalid file type! Only .csv files are allowed.");
            this.$alertify.error("Invalid file type! Only .csv files are allowed.");
            this.clear1()
            return;
          }

          this.recoveryfilename = file.name;
          this.recoveryfile = file;

          // await this.parseFile1();

        } catch (err) {
          console.error("File validation error:", err);
        }

     },
     async parseFile1(){
        let count = 0; // cache the running count
        let csvData=[];
        let sheetid = 1;
        let validheader = 1;
        let sheetApproveKey = 'appoveDataKey1'
        let holdErrors = [];
        let approvalFor= this.approvalfor;
        var vm = this
          Papa.parse( this.recoveryfile, {
            header: true,
            skipEmptyLines: true,
            before: this.isLoading1 = true,
            worker: true, // Don't bog down the main thread if its a big file
            step: async function(result) {

              // Utility: Normalize object keys to lowercase
              const normalizeRow = (row) => {
                const normalized = {};
                Object.keys(row).forEach(k => {
                  normalized[k.toLowerCase()] = row[k];
                });
                return normalized;
              };

              // Utility: Push error
              const addError = (holdErrors, sheetid, message) => {
                holdErrors.push({ lineNumber: sheetid, message });
              };

              // Utility: Validate required fields
              const validateRequired = (row, field, holdErrors, sheetid, msg) => {
                if (!row[field]) addError(holdErrors, sheetid, msg || `${field} should not be empty.!`);
              };

              // Regex
              const numberRegex = /^[0-9]+$/;
              const floatRegex = /^([0-9]*[.])?[0-9]+$/;
              const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
              const alphaNumericRegex = /^[A-Za-z0-9\-_\/]+$/;

              // Required headers
              const requiredHeaders = [
                "shippingid",
                "employeeid/partnerid",
                "recoveredamount",
                "debitfromtype",
                "transaction/debitnoteid",
                "recoveryledgerid",
                "recoverylocationname",
                "recoverydate"
              ];

              // Validate headers once
              let fileHeaders = result.meta.fields.map(h => h.toLowerCase());
              console.log('fileHeaders ------------>>', fileHeaders);
              if (sheetid === 1 && !requiredHeaders.every(h => fileHeaders.includes(h))) {
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                validheader = 0;
              }

              // Process row
              sheetid ++;

              let row = normalizeRow(result.data); // all keys lowercase
              console.log('result.data ----------->>', result.data);
              let tempResult = {
                shippingid: row["shippingid"] || null,
                userid: row["employeeid/partnerid"] || null,
                recoveredamount: row["recoveredamount"] || null,
                debitfromtype: row["debitfromtype"] || null,
                transactiondebitnoteidno: row["transaction/debitnoteid"] || null,
                recoveryLedgerid: row["recoveryLedgerid"] || null,
                recoveryLocationName: row["recoverylocationname"] || null,
                recoveryDate: row["recoverydate"] || null,
              };

              // Shippingid.
              validateRequired(tempResult, "shippingid", holdErrors, sheetid, "shippingid cannot be empty.!");

              // DebitFromType
              validateRequired(tempResult, "debitfromtype", holdErrors, sheetid, "DebitFromType cannot be empty.!");
              if (tempResult.debitfromtype) {
                const debitType = tempResult.debitfromtype.toLowerCase().trim();
                const validTypes = ["servicecenter", "coloader", "courier", "networkvendor", "vendor", "store", "rsc"];
                if (!validTypes.includes(debitType)) {
                  addError(holdErrors, sheetid, "Invalid debitfromtype. Please provide a valid value.!");
                }
              }

              // UserId
              validateRequired(tempResult, "userid", holdErrors, sheetid, "employeeid/partnerid cannot be empty.!");
              if (tempResult.userid && !alphaNumericRegex.test(tempResult.userid)) {
                addError(holdErrors, sheetid, "employeeid/partnerid must be numeric.!");
              }
              if (csvData.some(el => el.userid === tempResult.userid && el.shippingid === tempResult.shippingid)) {
                addError(holdErrors, sheetid, "Duplicate USERID not allowed.!");
              }

              // typeofrecovery
              // validateRequired(tempResult, "typeofrecovery", holdErrors, sheetid, "typeofrecovery cannot be empty.!");
              // const typeofrecovery = (tempResult.typeofrecovery || "").toLowerCase().trim();
              // if (typeofrecovery && !["penalty", "cash"].includes(typeofrecovery)) {
              //   addError(holdErrors, sheetid, "type of recovery must be penalty/cash.!");
              // }

              // recoveredamount.
              validateRequired(tempResult, "recoveredamount", holdErrors, sheetid, "recoveredamount cannot be empty.!");
              if(tempResult.recoveredamount != null && tempResult.recoveredamount <= 0) {
                holdErrors.push({'lineNumber': sheetid, 'message': 'recoveredamount must be greater than zero.!'})
              }

              // recoveredamount.
              validateRequired(tempResult, "transactiondebitnoteidno", holdErrors, sheetid, "transaction/debitnoteid cannot be empty.!");

              if (tempResult.debitfromtype) {
                const mapTypes = {
                  "servicecenter": "ServiceCenter",
                  "coloader": "Coloader",
                  "courier": "Courier",
                  "networkvendor": "NetworkVendor",
                  "vendor": "Vendor",
                  "store": "Store",
                };
                tempResult.debitfromtype = mapTypes[tempResult.debitfromtype.toLowerCase().trim()] || tempResult.debitfromtype;
              }

              if(tempResult.shippingid != null && tempResult.userid != null && tempResult.recoveredamount != null  && tempResult.debitfromtype != null) {
                  csvData.push(tempResult);
              }

              // console.log("csvData ----------->>", csvData);

            },
            complete: function(){

              let lrpagelimit = this.UploadConfigDetails.pageCuttoff && this.UploadConfigDetails.pageCuttoff != '' ? this.UploadConfigDetails.pageCuttoff : '1001'
              let lrBatchlimit = this.UploadConfigDetails.batchCuttoff && this.UploadConfigDetails.batchCuttoff != '' ? this.UploadConfigDetails.batchCuttoff : '5000'
              // let lrpagelimit = 100
              // let lrBatchlimit=100
              // console.log('pagelimit ----->', lrpagelimit);
              // console.log('Batchlimit ----->', lrBatchlimit);
              // console.log('holdErrors ----->', holdErrors);
              if(validheader == 0){
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error('header mismatch issue, Please make ensure header should be in uppercase.!', "", "error");

              } else if(holdErrors.length > 0){
                this.errorList1 = holdErrors
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error('Invalid data in the file.', "", "error");

              } else if(csvData.length<1){
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error('Uploaded file is blank. At least one record set is required.', "", "error");
              } else if (csvData.length > lrpagelimit) {
                this.errorList1 = holdErrors
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error(`Allowed only ${lrpagelimit} shipments in one go, please upload file accordingly.`, "", "error");
              }
              else{
                this.recoveryFiledata = csvData;
                this.totalrecords = csvData.length;
                this.chunkArray1(this.recoveryFiledata, lrBatchlimit); //pass batch cuttoff
              }
            }.bind(this)
        });
        // }
      },
      async chunkArray1(myArray, chunk_size){
            try {
            console.log("Start Time", Date() );
            console.log("myArray =============>>>", myArray);
            this.attachmentLoader = true;
            this.recoveryProcessedSummary = true;
            var index = 0;
            var arrayLength = myArray.length;
            let tempArr = [];
            let promiseArray = []
            this.UpdateApprovalKey1 = [];
            this.PromiseChainResult1 = [];

            let chain = Promise.resolve();
            let self = this

            for(index = 0; index < arrayLength; index += chunk_size) {
              let myChunk = myArray.slice(index, index+chunk_size);
              // console.log('myChunk ----->>>>', myChunk);
              chain = chain.then(() => self.uploadHRApproval1(myChunk, index));
            }
            chain.then((result) => {
              console.log('Result  Test---->>', result);
              this.recoveryuploadResult = [];
              if(result) {
                let tempTotalCount = 0;
                let tempUploadedTotalCount = 0;
                this.recoveryuploadResult = this.PromiseChainResult1.flatMap(group =>
                  group.map(item => ({
                    shippingid: item.shippingid,
                    userid: item.userid,
                    recoverystatus: item.message,
                    recoveredamount: item.recoveredamount,
                    shipmentTotalPenalty: item.shipmentTotalPenalty,
                    remainingPenaltyAmount: item.totalRemainingAmount,
                    code: item.code
                  }))
                );

                let successCount = 0;
                let failureCount = 0;

                for (const item of this.recoveryuploadResult) {
                  if (item.code == 200) {
                    successCount++;
                  } else {
                    failureCount++;
                  }
                }

                this.successCount = successCount;
                this.failureCount = failureCount;

                console.log("End Time", Date());
                this.recoveryProcessedSummary = true;
                this.attachmentLoader = false;
                // this.triggerPopUpDialogForConfirmation1(this.recoveryuploadResult, reqObjectProcess)
                // this.downloadProcessedRecoverySummary(this.recoveryuploadResult)
              } else {
                this.recoveryProcessedSummary = true;
                 this.isLoading1 = false;
                 return false;
               }
               this.isLoading1 = false;
            })
            .catch((err) => {
              console.log('chain error', err);
            })
          }catch (err){
            console.log('function catch.',err);
          }
       },
       closeDebitFromModal(){
         this.recoveryProcessedSummary = false
       },
       uploadHRApproval1(myChunk, index) {
        return new Promise((resolve, reject) => {
          try {
            let batchId =`Penalty${(Math.random() + 1).toString(36).substring(9)}`;
            console.log("random", batchId);
            let newChunkArray = myChunk.map(chunk => Object.assign(chunk, {approvalkey: batchId}))
            this.UpdateApprovalKey1.push(batchId)
            // console.log("=======<<<<<<<<", this.localusermailid, this.recoveryfilename)
            let approveObj = {
              approvalShipments: newChunkArray,
              approvalKey: batchId,
              approvalFor: this.approvalfor,
              CreatedBy: this.localusermailid,
              filename: this.recoveryfilename
            }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'penaltyorcash/recovery',
              // url: 'http://localhost:3800/penaltyorcash/recovery',
              data: approveObj
            }).then(async approveHRresult => {
              this.batchkeyArray1.push(batchId)
              if (approveHRresult.data.code == 200) {
                this.PromiseChainResult1.push(approveHRresult.data.data)
                resolve(true)
              }else if (approveHRresult.data.code == 202){
                this.$alertify.error('Invalid data in csv file, '+ approveHRresult.data.message);
                this.recoveryProcessedSummary = false;
                this.attachmentLoader = false;
                resolve(false)
              } else {
                this.$alertify.error(approveHRresult.data.message);
                this.recoveryProcessedSummary = false;
                this.attachmentLoader = false;
                resolve(true)
              }

            }, error => {
              resolve(false)
              console.error(1,error)
              this.ConfirmLoader = false
            });
          } catch(e) {
            resolve(e)
          }
        })
      },
      downloadProcessedRecoverySummary( ArrayData = []){

        if ( ArrayData.length ) {
          let filtereddata = ArrayData.map((obj) => {
            return {
              "ShippingID": obj.shippingid,
              "EmployeeID / PartnerID": obj.userid,
              "Remarks/Message": obj.recoverystatus,
              // "Total Debit": obj.shipmentTotalPenalty,
              "Recovered Amount": obj.recoveredamount,
              // "Remaining Amount": obj.remainingPenaltyAmount,
              "Recovery Status": obj.code == 200 ? "Recovered" : "Not Recovered"
            };
          })
          this.downloadCsvFile( filtereddata )
        } else {
          this.$alertify.error('No Records found to exports csv.!');
        }
      },
      downloadCsvFile( downloadRecords ) {
        if( !downloadRecords.length ) {
          this.$alertify.error('No Records found to exports csv.!');
        }
        let csvContent = "data:text/csv;charset=utf-8,";
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        var today = dd + "" + mm + "" + yyyy;
        let filename = "recoveryoutputsummary" + today + ".csv";
        csvContent += [
          Object.keys(downloadRecords[0]).join(";"),
          ...downloadRecords.map(item => Object.values(item).join(";"))
        ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", filename);
        link.click();
      },
      getconfigFlags() {
        return new Promise((resolve,reject) => {
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'rediscluster/get',
            data: { "key": "uploadConfigskeysFlag" }
          }).then(async getconfigset => {
            console.log('getconfigset -->', getconfigset);
            resolve(getconfigset.data.message)
          })
        })
      },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if ( result ) {
          console.log("Form Submitted result -------->>", result);
          this.parseFile1()
        }
      }).catch((e) => {
        console.log('log errors', e);
      });
    },
    clear1(){
      this.UpdateApprovalKey1 = [];
      this.PromiseChainResult1 = [];
      this.isLoading1 = false;
      this.recoveryFiledata = [];
      this.recoveryfilename = null;
      this.recoveryfile = ''
      this.uploadApprovecsv1 = ''
      this.approvalfor = '0'
      this.errorList1 = []
      const input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';

      console.log('file cleared.!');
      this.$validator.reset();
      this.errors.clear();
    },
    downloadsampleformat1(fileType) {
      let sampleDataHR = [
        {
          "shippingid": "123456789",
          "employeeid/partnerid": "1234",
          "Recoveredamount": "2000",
          "debitfromtype":"servicecenter",
          "transaction/debitnoteid":"txn0101",
          "recoveryLedgerid":"123",
          "recoveryLocationName": "Ledger XYZ",
          "recoveryDate": "2026-03-10"
        }
      ];
      let sampleData='';
      if(fileType==="penalty"){
         sampleData=sampleDataHR
      }else if(fileType==="financerecovery"){
         sampleData=sampleDataFinancerecovery
      }else{
         sampleData=sampleDataFinance;
      }
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "uploadSamleFormat"+fileType+ + today + ".csv";
      csvContent += [
        Object.keys(sampleData[0]).join(","),
        ...sampleData.map(item => Object.values(item).join(","))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    setApprovalFor(e){
      this.approvalfor=e.target.value;
    },
    filterclear(){
      // this.debitModeObj = {}
      this.StatusObj = {},
      this.status = ''
      this.fromDate='';
      this.toDate='';
      this.debitFrom='';
      this.debitFromObj = {value: "",text: "" }
      this.shippingID='';
      this.employeeID='';
      this.pageno = 1;
      this.pagecount = 0;
      this.$validator.reset();
      this.errors.clear();
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/shipmentRecoveryApproval/shipmentRecoveryApproval.component.js